import gql from 'graphql-tag';

import { QUESTION_RESPONSE_FRAGMENT, QuestionResponse } from './question-response.types';
import { GuestStatus } from './guest.enums';

export interface PlusOneConfig {
  allowPlusOnes: boolean;
  maxPlusOnes: number;
  collectQuestionnaireResponses: boolean;
  maxRegisteredPlusOnes?: number;
}

export interface PlusOneGuest {
  plusOneId: number;
  eventId: number;
  firstName: string;
  lastName: string;
  status: GuestStatus;
  isCheckedIn?: boolean;
  questionnaireResponses: QuestionResponse[];
}

export const SINGLE_EVENT_PLUS_ONE_GUEST_FRAGMENT = gql`
  fragment SingleEventPlusOneFields on PlusOneGuest {
    __typename
    plusOneId
    eventId
    firstName
    lastName
    status
    isCheckedIn
    questionnaireResponses {
      ...QuestionResponseFields
    }
  }
  ${QUESTION_RESPONSE_FRAGMENT}
`;

export interface EditablePlusOne {
  plusOneId?: number;
  uuid: string;
  firstName: string;
  lastName: string;
  email: string | null;
  questionnaireResponses: Record<number, string | string[] | null>;
}

export interface PlusOneGuestSessionStatus {
  eventId: number;
  status: GuestStatus;
}

export interface MultiSessionPlusOneGuest {
  plusOneId: number;
  eventId: number;
  firstName: string;
  lastName: string;
  sessionStatus: PlusOneGuestSessionStatus[];
  isCheckedIn?: boolean;
  questionnaireResponses: QuestionResponse[];
}

export const MULTI_SESSION_EVENT_PLUS_ONE_GUEST_FRAGMENT = gql`
  fragment MultiSessionEventPlusOneFields on MultiSessionPlusOneGuest {
    __typename
    plusOneId
    eventId
    firstName
    lastName
    sessionStatus {
      eventId
      status
    }
    questionnaireResponses {
      ...QuestionResponseFields
    }
  }
  ${QUESTION_RESPONSE_FRAGMENT}
`;

export interface QuestionnaireInput {
  id: number;
  response: string | string[] | null;
}

export interface PlusOneGuestInput {
  plusOneId?: number;
  firstName: string;
  lastName: string;
  email?: string;
  questionnaireResponses?: QuestionnaireInput[];
  sessionIds?: number[];
}

export interface SingleEventPlusOneGuestInput {
  plusOneId?: number;
  firstName: string;
  lastName: string;
  questionnaireResponses?: QuestionResponse[];
}

export interface MultiSessionEventPlusOneGuestInput {
  plusOneId?: number;
  firstName: string;
  lastName: string;
  questionnaireResponses?: QuestionResponse[];
  sessionStatus: PlusOneGuestSessionStatus[];
}
